export default "__VITE_ASSET__C$FVMmgJ__"